module.exports = __webpack_public_path__ + "static/handleandkate-logo-6d09d043dfb3eb0ce159ed1b40ba2f21.svg";